import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import MCategorieCard from '../molecules/_molecules.categorie-card';

export default function OCategorie({ href, items }) {
	return (
		<article className="o-default-list o-large-list">
			{
				items.map((item) => {
					return (
						<MCategorieCard
							key={get(item, 'uuid', '')}
							title={get(item, 'name', '')}
							slug={get(item, 'slug', '')}
							img={get(item, 'image.url', '')}
							href={href}
						/>
					);
				})
			}
		</article>
	);
}

OCategorie.propTypes = {
	href: PropTypes.string,
	items: PropTypes.array.isRequired,
};

OCategorie.defaultProps = {
	href: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.categorie.js